
export const gtagHelperFunction = (action,eventCategory,eventLabel) => {
    try {
        window.gtag("event", action, {
            event_category: eventCategory,
            event_label: eventLabel,
        })
      } catch (error) {
        console.log(error);
      }
}